package com.xtream.data_kmp.dto



import androidx.room3.Entity
import androidx.room3.Ignore
import androidx.room3.Index
import androidx.room3.PrimaryKey
import com.xtream.data_kmp.db.utils.tryFormat
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

/**
 * {
"num":1,
"name":"AR: The Big bang Theory",
"series_id":1,
"cover":"https:\/\/images-na.ssl-images-amazon.com\/images\/I\/61K8bJwneQL._AC_SL1067_.jpg",
"plot":"A woman who moves into an apartment across the hall from two brilliant but socially awkward physicists shows them how little they know about life outside of the laboratory.",
"cast":"",
"director":"Mark Cendrowski",
"genre":"Comedy - Romance",
"releaseDate":"24-09-2018",
"last_modified":"1629233865",
"rating":"8",
"rating_5based":4,
"backdrop_path":[
"http:\/\/vod-logo.net\/photos\/3ca5f83c9a6933fc940a809794849836.jpg"
],
"youtube_trailer":"",
"episode_run_time":"22",
"category_id":"266"
}
 */
const val seriesStreamsTable="seriesStreamsTable"

@Serializable
@Entity(seriesStreamsTable,

    indices = [Index(value = ["categoryId"])]
    )
data class SeriesStream(
    @SerialName("series_id")
    @PrimaryKey
   override val streamId: Int,
    override val num: Int?=null,
    override val name: String="",

    val plot: String?="",

    @SerialName("cover")
    override val streamIcon: String?=null,
    val cast: String?="",
    val director: String?="",
    val genre: String?="",
    val releaseDate: String?="",
    @SerialName("last_modified")
    val lastModified: String?="",
    val rating: String?=null,
    @SerialName("rating_5based")
    val ratingFiveBased: String?=null,

    @SerialName("backdrop_path")
    @kotlinx.serialization.Serializable(UnwrappingJsonListSerializer::class)
    val backdropPath:List<String?>?=null,
    @SerialName("youtube_trailer")
    val youtubeTrailer: String?="",
    @SerialName("episode_run_time")
    val episodeRunTime: String?="",
    @SerialName("category_id")
    override val categoryId: Int?=0,
    @Deprecated("streamType is deprecated", replaceWith = ReplaceWith("type"))
    @SerialName("stream_type")
    override val streamType: String="series"

): BaseStream  {
    @Transient
    @Ignore
    override val type: StreamType=StreamType.POSTER
    //ignore Serialization to all next properties

    @Transient
    @Ignore
    override val added: String=""

    @Transient
    @Ignore
    override val customSid: String?=null

    @Transient
    @Ignore
    override val directSource: String?=null

    @Transient
    @Ignore
    override val isAdult: Int=0


    fun formattedRating():String=
        rating?.tryFormat(
            /*locale = Locale.ENGLISH,
            "%.1f",*/
            alt = rating
        ) ?: ""





}

/*





    @SerialName("stream_icon")
    override val streamIcon: String?=null,




    @SerialName("custom_sid")
    override val customSid: String?=null,

    @SerialName("stream_type")
    override val streamType: String="",
    override val added: String="",
 @SerialName("container_extension")
    val containerExtension: String,
@SerialName("direct_source")
    override val directSource: String?=null,
@SerialName("is_adult")
    override val isAdult: Int=0,
    @SerialName("stream_id")
    @Unique( onConflict = ConflictStrategy.REPLACE)
    override val streamId: Int,
 */